import React, {FC, PropsWithChildren} from 'react';
import {Button} from "@/components/ui/button.tsx";
import {LucideLoaderCircle} from "lucide-react";

type Props = {
    text?: string;
    icon?: React.ReactElement;
    onClick?: () => void;
    isLoading?: boolean;
    disabled?: boolean;
}

const ELoadingButton: FC<PropsWithChildren<Props>> = ({text, icon, onClick, isLoading, disabled}) => {
    return (
        <Button onClick={onClick}
                disabled={isLoading || disabled}
                type='button'
                className='flex items-center gap-2.5'>
            {(icon && isLoading !== true) && icon}
            {isLoading && (
                <LucideLoaderCircle className={"animate-spin h-5 w-5 stroke-popover-400"} />
            )}
            <span className={"text-white"}>{text}</span>
        </Button>
    );
};

export default ELoadingButton;